import { render, staticRenderFns } from "./TimeTagButton.vue?vue&type=template&id=0f2f802d&"
import script from "./TimeTagButton.vue?vue&type=script&lang=ts&"
export * from "./TimeTagButton.vue?vue&type=script&lang=ts&"
import style0 from "./TimeTagButton.vue?vue&type=style&index=0&id=0f2f802d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports